import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

export default function useManageFile(): {
  acceptedImageType: string;
  acceptedWaiverType: string;
  getWaiverPath: (eventId: string, fileName: string) => string;
  getQRFlyerPath: (eventId: string) => string;
  getQRBasicPath: (eventId: string) => string;
  getQREventPath: (eventId: string) => string;
  getDefaultWaiverPath: (fileName: string) => string;
  openFile: (path: string) => Promise<string>;
  isValidType: (file: File, acceptedFileTypes: string) => boolean;
  upload: (file: File, filePath: string) => Promise<void>;
  getEventFile: (eventId: string, fileName: string) => Promise<string>;
  uploadEventFile: (eventId: string, file: File) => Promise<void>;
  // eslint-disable-next-line indent
} {
  const acceptedImageType = ".png, .jpg, .jpeg";

  const acceptedWaiverType = ".pdf, .png, .jpg, .jpeg";

  const getDefaultWaiverPath = (fileName: string) => `system/waiver/${fileName}`;

  const getWaiverPath = (eventId: string, fileName: string) => `events/${eventId}/${fileName}`;
  const getQRFlyerPath = (eventId: string) => `events/${eventId}/qr-codes/flyers.pdf`;
  const getQRBasicPath = (eventId: string) => `events/${eventId}/qr-codes/basic-flyers.pdf`;
  const getQREventPath = (eventId: string) => `events/${eventId}/qr-codes/event-qr.pdf`;

  const openFile = async (path: string): Promise<string> => {
    if (path) {
      const storage = getStorage();
      const fileRef = storageRef(storage, path);
      const url = await getDownloadURL(fileRef);
      return url;
    }

    return "";
  };

  const getEventFile = async (eventId: string, fileName: string): Promise<string> =>
    openFile(`events/${eventId}/${fileName}`);

  const uploadEventFile = async (eventId: string, file: File): Promise<void> => {
    const storage = getStorage();
    const storageRefInst = storageRef(storage, `events/${eventId}/${file.name}`);
    await uploadBytes(storageRefInst, file);
  };

  const isValidType = (file: File, acceptedFileTypes: string): boolean => {
    let valid = false;
    const acceptedFileTypesArray = acceptedFileTypes.split(", ");
    // check extension
    const fileName = file.name.toLowerCase();
    for (const ext of acceptedFileTypesArray) {
      if (fileName.endsWith(ext)) {
        valid = true;
        break;
      }
    }
    return valid;
  };

  const upload = async (file: File, filePath: string): Promise<void> => {
    const storage = getStorage();
    const storageRefInst = storageRef(storage, filePath);
    await uploadBytes(storageRefInst, file);
  };

  return {
    acceptedImageType,
    acceptedWaiverType,
    getDefaultWaiverPath,
    getWaiverPath,
    openFile,
    isValidType,
    upload,
    getEventFile,
    uploadEventFile,
    getQRFlyerPath,
    getQRBasicPath,
    getQREventPath,
  };
}
